/** @format */

export const NavigateUpMedium = ({color}) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M18 14L12 8L6 14L18 14Z" fill={color} />
        </svg>
    );
};
